import type { ReactNode } from 'react';
import { Link as ToolkitLink } from 'components/Toolkit/Button/Link';
import type { LinkProps as ToolkitLinkProps } from 'components/Toolkit/Button/SharedLink';
import type { NextLinkProps, LinkProps, Url } from 'types';

interface OptionalLinkWrapperProps extends Omit<LinkProps, 'href'> {
  children: ReactNode | string;
  Link?: NextLinkProps;
  href?: Url | string;
  isExternal?: boolean;
  isUnderscoreBlankIfExternal?: boolean;
  toolkitLinkProps?: ToolkitLinkProps;
  nofollow?: boolean;
}

function OptionalNextLink({
  children,
  Link,
  href,
  isExternal = false,
  isUnderscoreBlankIfExternal = true,
  toolkitLinkProps,
  nofollow = true,
  ...args
}: OptionalLinkWrapperProps) {
  return (
    <>
      {Link && href ? (
        isExternal ? (
          // IDE error is incorrect
          // eslint-disable-next-line react/jsx-no-target-blank
          <a
            href={href as string}
            target={isUnderscoreBlankIfExternal ? '_blank' : undefined}
            rel={
              isUnderscoreBlankIfExternal
                ? `noopener noreferrer${nofollow ? ' nofollow' : ''}`
                : undefined
            }
          >
            {typeof children === 'string' ? (
              <ToolkitLink {...toolkitLinkProps} isFakeLink={true}>
                {children}
              </ToolkitLink>
            ) : (
              children
            )}
          </a>
        ) : (
          <Link href={href} {...args}>
            <a>
              {typeof children === 'string' ? (
                <ToolkitLink {...toolkitLinkProps} isFakeLink={true}>
                  {children}
                </ToolkitLink>
              ) : (
                children
              )}
            </a>
          </Link>
        )
      ) : (
        <>
          {typeof children === 'string' ? (
            <ToolkitLink {...toolkitLinkProps} isFakeLink={true}>
              {children}
            </ToolkitLink>
          ) : (
            children
          )}
        </>
      )}
    </>
  );
}

export { OptionalNextLink };
